import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row, Button, Input, InputGroup, InputGroupText, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import CommonTableNew from '../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew';
import { getData } from '../../../CommonElements/Functions/PostGetFun';
import { API } from '../../../api/API';
import { useNavigate } from 'react-router-dom';
import { Image } from '../../../AbstractElements';
import { dynamicImage } from '../../../Utils';
import MonthDropdown from '../../CommonCompo/MonthDropdown';

const LeaveApprovals: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [leaveData, setLeaveData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filterStatus, setFilterStatus] = useState<string>('Pending'); // default to Pending (no API filter)
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [statusData, setStatusData] = useState<Record<string, string>>({});
  const [selectedValue, setSelectedValue] = useState<string>("1");
  const [designationFilter, setDesignationFilter] = useState<string>();


  
  const navigate = useNavigate();
  const serverUrl = localStorage.getItem('serverUrl');

  const statusMap: Record<number | string, string> = {
    1: 'Pending',
    2: 'Approved',
    3: 'Rejected',
  };

  const headData = [
    { id: '1', head: 'Employee Code',      key: 'EmployeeCode', sortKey: 'EmployeeCode' },
    { id: '2', head: 'Employee',   key: 'EmployeeName',    sortKey: 'FirstName' },
    { id: '3', head: 'Designation', key: 'DesignationName', sortKey: 'DesignationName' },
    { id: '3', head: 'TotalLeaveCount', key: 'TotalLeaveCount', sortKey: 'TotalLeaveCount' },
    // { id: '4', head: 'Status',      key: 'StatusText',      sortKey: 'StatusSort' },
    { id: '5', head: 'Action',      key: 'Action',          sortKey: '' },
  ];

  // Fetch with API filter (All -> 'A', Pending -> no filter param)
  const fetchPendingLeaves = async (apiFilter?: 'A') => {
    setLoading(true);
    try {
      const url = `${serverUrl}${API.pendingAdminLeaveCountList}`;
      const params = {moye:selectedMonth,status:selectedValue}
      console.log("Fetching URL:", url, "with params:", params);
      
      const { status, data } = await getData(url, true, params);

      const ok = status === 200 || (data && data.statusCode === 200);
      const payload = data?.data ?? (data ?? []);
      
      console.log(payload , "======== person leave===== ");

      if (ok && Array.isArray(payload)) {
        setLeaveData(payload);
      } else if (Array.isArray(data)) {
        setLeaveData(data);
      } else {
        setLeaveData([]);
      }
    } catch (err) {
      console.error('Failed to fetch pending leaves', err);
      setLeaveData([]);
    } finally {
      setLoading(false);
    }
  };

  
  // Refetch when dropdown selection changes
  useEffect(() => {
    // Pending => no filter param, All => filter=A
    const apiFilter = filterStatus === 'All' ? 'A' : undefined;
    fetchPendingLeaves(apiFilter);
  }, [filterStatus, serverUrl,selectedMonth,selectedValue ]);

  // Apply client-side search (and keep a safety Pending filter)
  useEffect(() => {
    let data = [...leaveData];

    if (searchTerm) {
      data = data.filter((item) => {
        const fullName = `${item.FirstName || ''} ${item.LastName || ''}`.toLowerCase();
        const designation = item?.Designations?.Designation?.toLowerCase() || '';
        const empcode = item?.EmployeeCode.toLowerCase() || '';
        return (
          fullName.includes(searchTerm.toLowerCase()) ||
          designation.includes(searchTerm.toLowerCase())||
          empcode.includes(searchTerm.toLowerCase())
        );
      });
    }
    if(designationFilter){
     data = data.filter((m) => {
        const matchesDesignation = !designationFilter || m.Designations?.Designation === designationFilter;
          return matchesDesignation
      })

    }


    if (filterStatus === 'Pending') {
      data = data.filter((item) => item.Status === 1);
    }

    setFilteredData(data);
  }, [searchTerm, filterStatus, leaveData ,designationFilter,  ]);


  const displayData = filteredData.map((row) => ({
    ...row,
    EmployeeCode: row?.EmployeeCode || '-',
    EmployeeName: `${row.FirstName || ''} ${row.LastName || ''}`.trim(),
    DesignationName: row?.Designations?.Designation || '',
    TotalLeaveCount: Number(row?.TotalLeaveCount ?? 0),
    StatusText: statusMap[row?.Status] ?? String(row?.Status ?? ''),
    StatusSort: Number(row?.Status ?? 0),
  }));

    // fetching leave status 
    useEffect(()=>{
      const fetchLeaveStatusMap = async () => {
            if (!serverUrl) return;
            try {
              const url = `${serverUrl}${API.getLeaveStatus}`;
              const { status, data } = await getData(url, true);
              const payload = data?.data ?? data;
              if (status === 200 && payload ) {
                // payload example: { Submit: "0", Raised: "1", Approve: "2" }
               console.log(payload,"=====leave statusss==========");
               setStatusData( payload)
              }
            } catch (err) {
              console.error('Failed fetching leave status map', err);
            }
          };
      
          fetchLeaveStatusMap();
  },[])

 const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedValue(e.target.value);
    console.log("Selected value:", e.target.value);
  };
  
  // {console.log(statusData,"=======statusdata======")}
  {console.log(selectedMonth,"=======selectedMonth======")}
  return (
    <div className="px-2">
      <Container fluid>
        <Col xxl={12}>
          {/* Search and Filter Controls */}
          <div className="d-flex justify-content-between align-items-center mb-3 py-2">
            {/* Search Input */}
            <div style={{ maxWidth: '300px' }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Name or Designation"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
              <div  className='d-flex justify-content-between align-items-center gap-5'>
                <div>
                  <select
                className="form-control border"
                value={designationFilter}
                onChange={(e) => setDesignationFilter(e.target.value)}
                style={{ width: '200px' }}
              >
                <option value="">All Designations</option>
                {Array.from(
                  new Set(leaveData?.map((m) => m.Designations?.Designation).filter(Boolean))
                ).map((designation, index) => (
                  <option key={index} value={designation}>
                    {designation}
                  </option>
                ))}
              </select>
                </div>
                {/* {Leaves Statues} */}
                <div >
                  <select  className="form-select" value={selectedValue} onChange={handleChange}>
                    <option value="">Select Status</option>
                    {Object.entries(statusData).map(([label, value]) => (
                      <option key={value} value={value}>
                       {label}
                      </option>
                      ))}
                    </select>
                </div>
                {/* {Month dropdown} */}
                <div>
                <MonthDropdown onChange={(value) => setSelectedMonth(value)} />
                </div>
              </div>
            {/* Dropdown for Filter */}
            {/* <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle caret color="primary">
                {filterStatus}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => setFilterStatus('Pending')}>Pending</DropdownItem>
                <DropdownItem onClick={() => setFilterStatus('All')}>All</DropdownItem>
              </DropdownMenu>
            </Dropdown> */}
          </div>

          {/* Table */}
          {loading ? (
            <div className="text-center py-3">
              <div>
                <Image
                  className="b-r-10 img-80"
                  src={dynamicImage('dashboard/loader.gif')}
                  alt="Loading..."
                />
              </div>
            </div>
          ) : (
            <CommonTableNew
              caption=""
              headData={headData}
              data={displayData}
              renderRow={(row: any, rowIndex: number) => (
                <tr key={rowIndex}>
                  <td>{row.EmployeeCode || '-'}</td>
                  <td>{row.EmployeeName || '-'}</td>
                  <td>{row.DesignationName || '-'}</td>
                  <td>{row.TotalLeaveCount || '-'}</td>
                  {/* <td>{row?.TotalLeaveCount ?? 0}</td> */}
                  {/* <td>{row.StatusText || '-'}</td> */}
                  <td>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() =>
                        navigate('/leaveDashboard', {
                          state: {
                            empId: row.EmployeeId,
                            name: row.EmployeeName,
                          },
                        })
                      }
                    >
                      View
                    </Button>
                  </td>
                </tr>
              )}
            />
          )}
        </Col>
      </Container>
    </div>
  );
};

export default LeaveApprovals;
 